import { PinComponent } from '@lessonup/pins-shared';
import { useMemo } from 'react';
import { getActiveDropzoneIds, isActiveDropzone } from './useLinkedPinComponents/dropzone/dropzoneUtils';
import {
  getActiveHotspotIds,
  getLinkedToInactiveHotspotIds,
  isActiveHotspot,
  isLinkedToHotspotList,
  isLinkedToInactiveHotspot,
} from './useLinkedPinComponents/hotspot/hotspotUtils';

export const useLinkedPinComponents = (pinComponents: PinComponent[], selectedPinComponentIds?: string[]) => {
  // ============================================================================
  // HOTSPOT LOGIC
  // ============================================================================

  // Get active hotspots (toggled or selected)
  const activeHotspotIds = useMemo(() => {
    return getActiveHotspotIds(pinComponents, selectedPinComponentIds ?? []);
  }, [pinComponents, selectedPinComponentIds]);

  // Get components linked to inactive hotspots (these should be hidden)
  const linkedToInactiveHotspotIds = useMemo(() => {
    return getLinkedToInactiveHotspotIds(pinComponents, activeHotspotIds);
  }, [pinComponents, activeHotspotIds]);

  // ============================================================================
  // DROPZONE LOGIC
  // ============================================================================

  // Get active dropzones (selected or have linked components)
  const activeDropzoneIds = useMemo(() => {
    return getActiveDropzoneIds(pinComponents, selectedPinComponentIds);
  }, [pinComponents, selectedPinComponentIds]);

  // ============================================================================
  // RETURN ALL FUNCTIONS
  // ============================================================================

  return {
    // Hotspot functions
    isLinkedToInactiveHotspot: (pinComponentId: string) =>
      isLinkedToInactiveHotspot(pinComponentId, linkedToInactiveHotspotIds),
    isLinkedToHotspotList: (pinComponentId: string, hotspotIds: string[]) =>
      isLinkedToHotspotList(pinComponentId, hotspotIds, pinComponents),
    isActiveHotspot: (pinComponentId: string) => isActiveHotspot(pinComponentId, activeHotspotIds),

    // Dropzone functions
    isActiveDropzone: (pinComponentId: string) => isActiveDropzone(pinComponentId, activeDropzoneIds),
  };
};
